import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const FileErrorModal = ({ visible, onHide, errorDetails, tutorialUrl }) => {
  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      modal
      closable={false}
      showHeader={false}
      style={{ width: '90%', maxWidth: '750px', borderRadius: '16px' }}
      contentStyle={{ padding: '2.5rem 2rem 1.5rem 2rem', borderRadius: '16px' }}
    >
      <div className="flex flex-column align-items-center text-center">
        {/* Ícone Superior de Alerta/PDF */}
        <div 
          className="flex align-items-center justify-content-center border-circle mb-3"
          style={{ width: '60px', height: '60px', backgroundColor: '#FEE2E2', color: '#EF4444' }}
        >
          <i className="pi pi-file-pdf" style={{ fontSize: '1.8rem' }}></i>
        </div>

        {/* Título e Subtítulo */}
        <h2 className="text-900 text-2xl font-bold mb-2">
          Problemas na leitura do seu Arquivo
        </h2>
        <p className="text-600 font-medium mb-1 mt-0">
          Seu arquivo foi identificado como incompatível para importação.
        </p>
        <p className="text-500 text-sm mt-0 mb-4">
          Veja abaixo os possíveis problemas e como resolvê-los.
        </p>

        {/* Card Principal de Erro */}
        <div 
          className="w-full text-left p-4 border-round-xl mb-4"
          style={{ 
            backgroundColor: '#FEF2F2', 
            border: '1px solid #FCA5A5' 
          }}
        >
          {/* Cabeçalho do Card */}
          <div className="flex align-items-center justify-content-between mb-3 pb-2 border-bottom-1 border-red-200">
            <div className="flex align-items-center gap-2">
              <div 
                className="flex align-items-center justify-content-center border-round p-2"
                style={{ backgroundColor: '#FEE2E2', color: '#EF4444' }}
              >
                <i className="pi pi-file" style={{ fontSize: '1.2rem' }}></i>
              </div>
              <span className="font-bold text-red-600 text-base">
                PDF composto apenas por imagens
              </span>
            </div>

            <span 
              className="text-white text-xs font-semibold px-3 py-1 border-round-caps"
              style={{ backgroundColor: '#EF4444' }}
            >
              Problema detectado
            </span>
          </div>

          {/* Descrição do Erro */}
          <p className="text-700 text-sm line-height-3 mb-4">
            {errorDetails || 'O arquivo PDF não contém texto extraível. Todas as páginas são imagens escaneadas ou fotografadas, o que impede a leitura automática dos lançamentos pelo sistema.'}
          </p>

          {/* Seção Como Resolver */}
          <span className="font-bold text-xs uppercase text-blue-700 block mb-2 tracking-wider">
            COMO RESOLVER
          </span>

          <ul className="m-0 pl-3 text-700 text-sm line-height-3 flex flex-column gap-2 mb-4">
            <li>
              Solicite ao banco ou ao sistema emissor o arquivo em formato PDF original, ou seja, que não tenha sido gerado por meio de digitalização.
            </li>
            <li>
              Caso disponha de outro formato de arquivo (como: XLS, XLSX, CSV, OFX, TXT ou HTML), você poderá verificar se existe algum layout compatível em nosso sistema.
            </li>
            <li>
              Em caso de dúvidas, entre em contato com o nosso time de Suporte.
            </li>
          </ul>

          {/* Card de Vídeo Tutorial */}
          <div 
            className="surface-card border-round-lg p-3 flex align-items-center justify-content-between cursor-pointer hover:surface-100 transition-duration-150"
            style={{ border: '1px solid #E5E7EB' }}
            onClick={() => window.open(tutorialUrl || 'https://youtube.com', '_blank')}
          >
            <div className="flex align-items-center gap-3">
              <i className="pi pi-youtube text-red-600" style={{ fontSize: '2rem' }}></i>
              <div className="flex flex-column">
                <span className="font-bold text-sm text-900">Assistir tutorial em vídeo</span>
                <span className="text-xs text-500">Veja como identificar um PDF que contenha somente imagens</span>
              </div>
            </div>
            <i className="pi pi-external-link text-400"></i>
          </div>
        </div>

        {/* Botão Voltar */}
        <Button
          label="Voltar"
          icon="pi pi-arrow-left"
          onClick={onHide}
          className="p-button-primary px-4 py-2 font-semibold"
          style={{ backgroundColor: '#4682B4', borderColor: '#4682B4' }}
        />
      </div>
    </Dialog>
  );
};

export default FileErrorModal;